import { OlympusClient } from '@/OlympusClient'
import { useFeatureFlags } from '@/utils/useFeatureFlags'

import textBuilderModule from '../../store'
import {
  type CampaignResource,
  type SmsSection,
  type SmsSectionCreate,
} from '../../types'

const LOCATION_SCOPED_FRANCHISEE_OTC_FLAG = 'hermes.locationScopedFranchiseeOtc'

export const createBlockHandler = async <
  TSection extends SmsSection,
  TSectionCreate extends SmsSectionCreate,
>(
  createData: TSectionCreate
): Promise<TSection> => {
  const currentResource = textBuilderModule?.getters?.currentResource as
    | CampaignResource
    | undefined

  if (!currentResource) {
    throw new Error(
      'createBlockHandler (text): textBuilderModule.getters.currentResource is undefined — wizard must call loadPreview before creating blocks'
    )
  }

  const { brandId, locationId } = currentResource
  const flagEnabled = useFeatureFlags().isEnabled(
    LOCATION_SCOPED_FRANCHISEE_OTC_FLAG
  )
  const fallbackLocationId = flagEnabled ? (locationId ?? null) : null

  return (await OlympusClient.notifications.v1.templates.sms.sections.createSMSSection(
    {
      body: {
        brandId,
        locationId: fallbackLocationId,
        ...createData,
      },
    }
  )) as TSection
}
